<div class="wrapper-page wrapper-my-list">
  <tl-header></tl-header>
  <div class="wrapper-header-my-lists">
    <div class="header-my-lists">
      <span>{{'LISTS.favorite_listers' | translate}}</span>
    </div>
  </div>
  <div class="wrapper-content-my-lists favorite-lists">
    <div class="content-my-lists">
      <div class="filter-my-lists">
        <div class="wrapper-custom-search">
          <img class="icon-search" src="../../../assets/icons/outline/icon-search.svg" alt="">
          <input type="text" placeholder="{{'NEW_TEXT.search' | translate}}" [(ngModel)]="searchTerm" (input)="onSearchChange($event)">
          <div class="wrapper-delete-search" (click)="resetSearch()">
            <img src="../../../assets/icons/outline/icon-close.svg" alt="">
          </div>
        </div>
      </div>
      <div *ngFor="let lister of favoriteListers" class="wrapper-card-lister"
        [routerLink]="[PAGES_AND_PATHS.profile.pagePath, lister.username]">
        <div class="wrapper-favorite-lister">
          <div class="wrapper-avatar">
            <img *ngIf="lister.profile_photo_url === null"
                 [src]="(lister.subscriptions | checkActiveRole) === UserRoles.expert ? '../../../../assets/images/avatar-user-expert.png' : '../../../../assets/images/avatar-user.png'"
                 alt="">
            <img *ngIf="lister.profile_photo_url !== null"
                 [src]="lister.profile_photo_url" alt="">
          </div>
          <div class="wrapper-user-info">
            <div class="wrapper-username">
              <span>{{lister.name}}</span>
              <img *ngIf="(lister.subscriptions | checkActiveRole) === UserRoles.expert" src="../../../assets/icons/fill/icon-badge.svg" alt="">
              <img *ngIf="(lister.subscriptions | checkActiveRole) === UserRoles.company"
                   src="../../../assets/icons/fill/icon-fill-company.svg" alt="">
            </div>
            <span>{{lister.followers_count}} {{lister.followers_count === 1 ? ('FOLLOWING_FOLLOWERS.followers' |
              translate) :
              ('FOLLOWING_FOLLOWERS.followers' | translate)}}</span>
          </div>
        </div>
        <div class="wrapper-send-btn">
          <button (click)="toggleFavoriteProfile(lister)" class="custom-btn"
            [ngClass]="lister.am_i_favorite_this_user ? 'custom-btn--circle-primary' : 'custom-btn--circle-outline'">
            <img src="../../../../assets/icons/fill/icon-heart.svg" alt="">
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
